import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link, router } from '@inertiajs/react'
import Button from '../../components/Button'

const ROLE_LABELS = { member: 'Medlem', admin: 'Lagadmin' }

export default function InvitationsIndex({ team, invitations }) {
  const base = window.location.origin

  function copyLink(token) {
    navigator.clipboard.writeText(`${base}/invitations/${token}`)
    alert('Länk kopierad till urklipp!')
  }

  function deleteInvitation(id) {
    if (!confirm('Ta bort den här inbjudningslänken?')) return
    router.delete(`/teams/${team.id}/invitations/${id}`)
  }

  return (
    <AuthenticatedLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <Link href={`/teams/${team.id}`} className="text-sm text-indigo-600 hover:underline">
              ← {team.name}
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 mt-2">Inbjudningslänkar</h1>
          </div>
          <Link href={`/teams/${team.id}/invitations/new`}>
            <Button>Ny inbjudningslänk</Button>
          </Link>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
          {invitations.length === 0 && (
            <p className="px-4 py-8 text-center text-gray-500 text-sm">Inga inbjudningslänkar ännu.</p>
          )}
          {invitations.map(i => (
            <div key={i.id} className="flex items-center justify-between px-4 py-4">
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-gray-900">
                    {ROLE_LABELS[i.role]}
                  </span>
                  {!i.active && (
                    <span className="text-xs bg-red-100 text-red-600 px-1.5 py-0.5 rounded">
                      Utgången
                    </span>
                  )}
                </div>
                <p className="text-xs text-gray-400 mt-0.5">
                  Skapad av {i.created_by}
                  {i.expires_at && ` · går ut ${new Date(i.expires_at).toLocaleDateString()}`}
                </p>
                <p className="text-xs text-gray-400 font-mono mt-1">{`/invitations/${i.token}`}</p>
              </div>
              <div className="flex items-center gap-3">
                {i.active && (
                  <button
                    onClick={() => copyLink(i.token)}
                    className="text-sm text-indigo-600 hover:underline"
                  >
                    Kopiera länk
                  </button>
                )}
                <button
                  onClick={() => deleteInvitation(i.id)}
                  className="text-sm text-red-600 hover:underline"
                >
                  Ta bort
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
